export default __webpack_public_path__ + "static/media/access_anywhere.b082dbf1.svg";